import { Html } from '@react-three/drei'

export function LoadingScreen() {
  return (
    <Html
      fullscreen
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div style={{
        textAlign: 'center',
        color: '#333',
        fontFamily: 'CodinaCustom, sans-serif'
      }}>
        <h2>loading game...</h2>
        <div style={{
          width: '200px',
          height: '4px',
          background: '#ddd',
          borderRadius: '2px',
          margin: '20px auto'
        }}>
          <div style={{
            width: '100%',
            height: '100%',
            background: '#000',
            borderRadius: '2px',
            animation: 'loading 1s infinite linear',
            transformOrigin: '0% 50%'
          }} />
        </div>
      </div>
    </Html>
  );
}